import { formatBaseLibraryURL } from 'utils/search/formateCountQuery'
import { getAxiosCounted } from 'pages/api/axios'
import { IBasicCard, IEventCard } from 'constants/types/card.types'
import { IAnyObj, IOptions, IStringObj } from 'constants/types/common.types'
import { Key, CARDS_ON_PAGE } from 'constants/search-data/search-data'
import { URL, NMOCodes, Option } from 'constants/search-data/webinar-search-data'
import { IgetCardsMaterials } from 'constants/types/search.types'
import { IInitParams } from 'constants/types/search.types'
import { coursesOrderBySpec } from './data'
import { ICourseNmoType } from 'constants/types/card.types'
import { Pathname } from 'constants/data'
import { BASE_URL } from 'constants/url'

const formatWebinarQuery = (prevParameters: IInitParams) => {
  const NMO = prevParameters[Key.NMO]
  let NMOQuery = ''
  if (NMO?.length === 1) {
    const NMOValue = NMO[0] === NMOCodes[0].value ? 'true' : 'false'
    NMOQuery = `&activeNMOCodes=${NMOValue}`
  }

  return NMOQuery
}

const getCardsMaterials: IgetCardsMaterials = async (
  params,
  isReset,
  usedCardsCount,
  selectedOption
) => {
  const commonQuery = formatBaseLibraryURL(
    params[Key.TEXT] as string,
    params[Key.DATES] as Date[],
    params[Key.LECTURS] as IOptions[],
    params[Key.THEMES] as IOptions[],
    params[Key.SPECIALITIES] as IOptions[]
  )

  const additionalQuery = formatWebinarQuery(params)

  const limit = CARDS_ON_PAGE
  const offset = isReset ? 0 : (usedCardsCount - 1) * limit

  const finalWebinarURL = `${URL[selectedOption]}${commonQuery}${additionalQuery}&limit=${limit}&offset=${offset}`
  const finalVideoURL = `${BASE_URL.VIDEOPROJECTS}?count=true&limit=${limit}&offset=${offset}`

  const searchData =
    selectedOption === Option.videoProjects
      ? await getAxiosCounted(finalVideoURL)
      : await getAxiosCounted(finalWebinarURL)

  const webinar =
    searchData?.rows?.map((item: IBasicCard | IEventCard) => ({
      isWebinar: true,
      ...item,
    })) || []

  const newUsedCardsCount = isReset ? webinar.length : usedCardsCount + webinar.length

  return {
    totalPages: Math.ceil(searchData.count / limit),
    newUsedCardsCount,
    allItems: webinar,
    allCount: searchData.count,
  }
}

const getMatchSpeciality = (userSpec: IAnyObj): number[] => {
  // TODO: подумать нужна ли логика, если у пользователя не выбраны специальности
  if (!userSpec) return []
  const allSpec = Object.keys(coursesOrderBySpec).map((spec) => spec.toLowerCase())
  const matchSpec = userSpec?.find(({ name }: IStringObj) => allSpec.includes(name?.toLowerCase()))
  return coursesOrderBySpec[matchSpec?.name as keyof typeof coursesOrderBySpec]
}

const changeCoursesOrder = (initArray: ICourseNmoType[], order: number[]) => {
  return order?.map((index) => initArray[index])
}

const createUrlForBtn = (translation: string | undefined): string => {
  return `/${Pathname.NMO_COURSE}/${translation}`
}

const getQueryWords = (text: string) => {
  return text.toLowerCase().split(' ')
}

export { getCardsMaterials, getMatchSpeciality, changeCoursesOrder, createUrlForBtn, getQueryWords }
